// extracted by mini-css-extract-plugin
module.exports = {"date":"styles_date___Sunj","readMore":"styles_readMore__XwQzw","clickableTitle":"styles_clickableTitle__13sns"};